import React from 'react';
import { Gift } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const bonuses = [{
  num: '1',
  title: 'Planner de Alimentación Semanal',
  desc: 'Planillas listas para organizar todas tus comidas.'
}, {
  num: '2',
  title: 'Guía de Compras Sin Gluten',
  desc: 'Aprendé qué productos elegir y cuáles evitar.'
}, {
  num: '3',
  title: 'Lista de Colaciones Saludables',
  desc: 'Opciones rápidas para cualquier momento del día.'
}, {
  num: '4',
  title: 'Mini Guía de Cocina Sin Contaminación Cruzada',
  desc: 'Cómo cocinar seguro dentro de casa.'
}, {
  num: '5',
  title: 'Recetario Express',
  desc: 'Recetas rápidas para días con poco tiempo.'
}, {
  num: '6',
  title: 'Calendario de Hábitos Saludables',
  desc: 'Seguimiento diario de alimentación y bienestar.'
}];
export function Bonuses() {
  return <section className="py-24 bg-brand-600 relative overflow-hidden" data-id="element-14">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-15">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-brand-500 rounded-full blur-3xl opacity-50" data-id="element-16"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-brand-700 rounded-full blur-3xl opacity-50" data-id="element-17"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-18">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-19">
          <FadeIn data-id="element-20">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 text-white mb-6 backdrop-blur-sm" data-id="element-21">
              <Gift className="w-8 h-8" data-id="element-22" />
            </div>
            <h2 className="text-sm font-bold tracking-widest text-brand-200 uppercase mb-3" data-id="element-23">
              🎁 INCLUIDOS GRATIS
            </h2>
            <p className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-24">
              LOS 6 BONOS EXCLUSIVOS
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/15 transition-colors" data-id="element-26">
              <div className="inline-block px-3 py-1 rounded-lg bg-brand-500 text-white text-xs font-bold tracking-wider mb-4" data-id="element-27">
                BONUS {bonus.num}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 leading-tight" data-id="element-28">
                {bonus.title}
              </h3>
              <p className="text-brand-100 text-sm leading-relaxed" data-id="element-29">
                {bonus.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}